import { useQuery } from "@tanstack/react-query";
import { TranslatedObject } from "./util/sharedModels.ts";
import { doGet, doPost } from "./util/apiHelper.ts";
import { User } from "oidc-client-ts";
import { useAuthenticatedMutation } from "./util/queryHelper.ts";

export type Genre = TranslatedObject;

export interface GenreRequest {
  genres: Genre[];
}

export interface GenreResponse {
  genres: Genre[];
}

async function postGenres(
  user: User,
  request: GenreRequest,
): Promise<GenreResponse> {
  return doPost<GenreResponse>("/genres", user, request);
}

export function useCreateGenresMutation() {
  return useAuthenticatedMutation((genreRequest: GenreRequest, user: User) =>
    postGenres(user, genreRequest),
  );
}

async function getSupportedGenres(): Promise<Genre[]> {
  return doGet<GenreResponse>("/public/genres").then((genreResponse) =>
    genreResponse.genres.map((item) => ({
      name: item.name,
      translations: item.translations,
    })),
  );
}

export function useSupportedGenres() {
  return useQuery({
    queryKey: ["supportedGenres"],
    queryFn: getSupportedGenres,
  });
}
